export const environment = {
  production: false,
  local: false,
  environmentVariant: 'development',
  apiUrl: 'https://api.dgi.fne.dev.veone.net',
  superSetDomainBasePathUrl: 'https://superset.dgi.fne.dev.veone.net',
  postalDomainBasePathUrl: 'https://postal.dgi.fne.dev.veone.net',
  superSetClientId: 'e6161052e1b53c80c50499cf665c25d6',
  masterDomainName: 'dev.veone.io',
  baseUrl: 'https://backoffice.dgi.fne.dev.veone.net',
  baseHref: '/',
  redirectUrl: 'https://backoffice.dgi.fne.dev.veone.net',
  consoleBaseUrl: 'https://console.dgi.fne.dev.veone.net',
  googleOauthClientId: '',
  googleOauthRedirectUrl: '/connexion',
  facebookOauthAppId: '',
  facebookOauthRedirectUrl: '/connexion',
  appleOauthClientId: 'com.veone.service',
  appleOauthRedirectUrl: '/connexion',
  xApplicationId: 'f6034962-66e6-47b2-94e1-5cd5bb66efe4',
  googleMapAccessToken: 'AIzaSyDjA6B3HuPjfA1yvsWdxI02IqClo9weBPg',
  googleMapId: '4a140f7c07fc2ab',
  invoiceChartIds: {
    one: '137',
    two: '30',
    three: '31',
    four: '32'
  },
  receiptChartIds: {
    one: '62',
    two: '65',
    three: '67',
    four: '66'
  },
  organizationChartIds: {
    one: '51',
    two: '52',
    three: '106',
    four: '107'
  },
  paymentChartIds: {
    one: '186',
    two: '187',
    three: '188'
  }
};
